import AppLogo from './AppLogo'

export default AppLogo
